import React from 'react';
import Reveal from './Reveal';

const Story = () => {
    return (
        <section className="py-32 px-6 bg-wedding-beige/10">
            <Reveal>
                <div className="max-w-3xl mx-auto text-center">
                    <span className="text-4xl text-wedding-gold mb-6 block font-serif">“</span>
                    <p className="font-serif text-3xl md:text-5xl italic leading-relaxed text-wedding-charcoal">
                        We loved with a love that was more than love.
                    </p>
                    <div className="mt-10 flex flex-col items-center">
                        <div className="w-12 h-px bg-wedding-gold mb-6"></div>
                        <p className="text-xs uppercase tracking-[0.3em] text-wedding-gray font-medium">Edgar Allan Poe</p>
                    </div>
                </div>
            </Reveal>
        </section>
    );
}; export default Story;
